import { render } from "./StudentNotes.vue?vue&type=template&id=871bbcac&scoped=true"
import script from "./StudentNotes.vue?vue&type=script&lang=js"
export * from "./StudentNotes.vue?vue&type=script&lang=js"

import "./StudentNotes.vue?vue&type=style&index=0&id=871bbcac&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871bbcac"]])

export default __exports__